import { Alert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Header from "../Header";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

export function LinkOpeningProblemAlert({
  children,
}: PropsWithChildren<unknown>) {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <br />
      <Alert color="warning" fade={false}>
        <h2 className={"light-header"}>
          <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
          {t("playlist.linkProblem.title")}
        </h2>
        {children}
        <Link className="nav-link" to="/">
          <FontAwesomeIcon icon={faHome} /> {t("playlist.linkProblem.overview")}
        </Link>
      </Alert>
    </>
  );
}
